import axios from 'axios';


const api = axios.create({
    baseURL: process.env.REACT_APP_API_BACKEND || 'http://localhost:9002', // Substitua pela URL do seu backend
});

// Interceptor para adicionar token às requisições
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default api;